export const siteConfig = {
  name: 'Dr. Nthabiseng Matla\'s Medical Practice',
  description: 'Professional medical practice offering comprehensive healthcare services',
  url: 'https://drjohnson.com',
  ogImage: 'https://drjohnson.com/og-image.png',
  author: 'Dr. Nthabiseng Matla',
  email: 'admin@drmatla.co.za',
  phone: '+27 67 341 2883',
  whatsapp: '+27 67 341 2883',
  address: '32 Grey Avenue, Medivillage , Vereeniging 1939',
  officeHours: {
    monday: '9:00 AM - 5:00 PM',
    tuesday: '9:00 AM - 5:00 PM',
    wednesday: '9:00 AM - 5:00 PM',
    thursday: '9:00 AM - 5:00 PM',
    friday: '9:00 AM - 5:00 PM',
    saturday: '09:00 AM - 1:00 PM',
    sunday: 'Closed',
  },
  social: {
    facebook: 'https://www.facebook.com/share/19dhfi8LVq/?mibextid=wwXIfr',
    twitter: 'https://twitter.com/drjohnson',
    linkedin: 'https://linkedin.com/company/drjohnson',
    instagram: 'https://www.instagram.com/dr_matlan?utm_source=qr',
    youtube: 'https://youtube.com/@drnthabisengmatla?si=X99hH8_bZ5Ydv5El',
  },
  // appLinks: {
  //   ios: 'https://apps.apple.com/app/drjohnson',
  //   android: 'https://play.google.com/store/apps/details?id=com.drjohnson',
  //   huawei: 'https://appgallery.huawei.com/app/C106089471',
  // },
}
